import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { localizationSelectors } from '@/localization/localizationSelectors';
import { userDomainSelectors } from '@/header/userDomainSelectors';
import { selectOccasion } from '@/localization/selectors';
import { OccasionString } from '@/localization/constants';

export const useGetScopedContentLegacy = () => {
      const isLocalized = useSelector(localizationSelectors.isLocalized);
      const isLoggedIn = useSelector(userDomainSelectors.isAuthenticatedUser);
      const storeDetails = useSelector(localizationSelectors.storeDetails);
      const storeOccasion = useSelector(selectOccasion) as keyof typeof OccasionString;
      const occasion = OccasionString[storeOccasion] as OccasionString;

      const storeId = storeDetails?.storeNumber;
      const userLocalized = isLocalized ? "Localized" : "Unlocalized";
      const userAuthenticated = isLoggedIn ? "Authenticated" : "Unauthenticated";

      const scopedConditions = useMemo(() => {
        const conditions = [
            `{ OR: [{ authenticated: "Both" }, { authenticated: "${userAuthenticated}" }] }`,
            `{ OR: [{ localized: "Both" }, { localized: "${userLocalized}" }] }`,
            `{ OR: [{ occasion: "Both" }, { occasion: "${occasion}" }] }`
        ];

        if (storeId) {
            const storeWhere = `{ OR: [{ stores_contains: "${storeId}" }, { stores_exists: false }] }`;
            conditions.push(storeWhere);
        }

        return conditions;
    }, [userAuthenticated, userLocalized, occasion, storeId]);

    return scopedConditions
    
};